<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <h5>Quick links</h5>
          <div class="quick-links-content">
            <a href="https://www.signify.com/investors" target="_blank" none="">
              Investor relations</a
            >
            <a href="https://www.careers.signify.com/" target="_blank">
              Careers</a
            >
            <a href="https://www.signify.com/global/contact" target="_blank">
              Contact Signify</a
            >
            <a
              href="https://www.signify.com/global/privacy/legal-information/cookies-notice"
              target="_blank"
            >
              Cookie Notice</a
            >
            <a
              href="https://www.signify.com/global/privacy/legal-information/privacy-notice"
              target="_blank"
            >
              Privacy notice</a
            >
            <a
              href="https://www.signify.com/global/product-security"
              target="_blank"
            >
              Product security</a
            >
            <a
              href="https://www.signify.com/global/terms-of-use"
              target="_blank"
            >
              Terms of use</a
            >
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="contact-content">
            <h5>Contact</h5>
            <p>
              Boschdijk 525, 5621 JG<br />
              Eindhoven
            </p>
            <p>
              Postbus 80062, 5600 KA<br />
              Eindhoven
            </p>
            <a href="#" @click="onContactUs" class="underline">Contact us</a>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="companies-consumers-content">
            <h5>Companies</h5>
            <p>
              +31 (0)40 275 00 00<br />
              09.00 - 17.00 (mon - fri)
            </p>
            <h5>Consumers</h5>
            <p>
              00800 744 547 75<br />
              08:30 - 20:00 (mon - fri)
            </p>
            <p class="small">(International free number*)</p>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="follow-us-content">
            <h5>Follow us</h5>
            <div class="social-media">
              <img
                src="../../assets/images/icons/linkedin.png"
                alt="LinkedIn"
              />
              <img src="../../assets/images/icons/twitter.png" alt="Twitter" />
              <img
                src="../../assets/images/icons/instagram.png"
                alt="Instagram"
              />
              <img
                src="../../assets/images/icons/pinterest.png"
                alt="Pinterest"
              />
              <img src="../../assets/images/icons/youtube.png" alt="YouTube" />
            </div>
            <div class="signify"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="lint">
      <div class="container">
        <div class="lint-content">
          <a href="https://www.signify.com" target="_blank">Owner of site</a>
          <a
            href="https://www.signify.com/global/privacy/legal-information/cookies-notice"
            target="_blank"
            >Cookies</a
          >
          <a
            href="https://www.signify.com/global/privacy/legal-information/privacy-notice"
            target="_blank"
            >Privacy</a
          >
          <a href="https://www.signify.com/global/terms-of-use" target="_blank"
            >Terms of use</a
          >
          <a
            href="https://www.signify.com/global/product-security"
            target="_blank"
            >Product security</a
          >
          <router-link to="/acknowledgement">Acknowledgement</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactUsModal from "@/components/modals/ContactUsModal";

export default {
  name: "Footer",
  modals: {
    ContactUsModal,
  },
  methods: {
    onContactUs() {
      this.$modalRouter.push({
        name: "ContactUsModal",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: $white;
  text-decoration: none;
  &:hover {
    color: $white;
    &::after {
      text-decoration: none;
    }
  }
}

.footer {
  background-color: #3c3c41;
  color: $white;

  .row {
    padding: 1.5rem 0;
  }

  .quick-links-content {
    a {
      display: block;
      color: $white;
    }
  }
  .contact-content,
  .companies-consumers-content {
    a {
      color: $white;
    }
    p {
      color: $white;
    }
    .underline {
      text-decoration: underline;
    }
  }
  .follow-us-content {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    .social-media {
      display: flex;
      flex-flow: row nowrap;
      img {
        height: 22px;
        padding: 0 0.5rem;

        &:first-child {
          padding: 0 0.5rem 0 0;
        }

        &:last-child {
          padding: 0 0 0 0.5rem;
        }
      }
    }

    .signify {
      background: url("../../assets/images/signify.png") no-repeat;
      background-position: bottom left;
      background-size: contain;
      height: 100%;
      margin-top: auto;
      width: 100%;
      max-width: 200px;
    }
  }
  .lint {
    background-color: #252525;
    color: $white;
    .lint-content {
      display: inline-block;
      padding: 0.5rem 0;
      a {
        color: $white;

        &::after {
          content: "|";
          padding: 0 1rem;
        }
        &:last-child {
          &::after {
            content: "";
          }
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    .social-media {
      img {
        height: 20px !important;
        padding: 0 0.3rem !important;
        &:first-child {
          padding: 0 0.3rem 0 0 !important;
        }
        &:last-child {
          padding: 0 0 0 0.3rem !important;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .social-media {
      img {
        height: 22px !important;
      }
    }

    .signify {
      max-width: 175px !important;
    }
  }

  @media screen and (max-width: 576px) {
    .signify {
      height: 75px !important;
    }
  }

  @media screen and (max-width: 374px) {
    .signify {
      max-width: 150px !important;
    }
  }
}
</style>
